import { render } from "./CustomerAdminAutocomplete.vue?vue&type=template&id=c8c28488&scoped=true"
import script from "./CustomerAdminAutocomplete.vue?vue&type=script&lang=js"
export * from "./CustomerAdminAutocomplete.vue?vue&type=script&lang=js"

import "./CustomerAdminAutocomplete.vue?vue&type=style&index=0&id=c8c28488&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c28488"]])

export default __exports__